import React from "react";
import PropTypes from "prop-types";

import { scaleTime } from "d3-scale";

import { discontinuousTimeScaleProviderBuilder } from "react-stockcharts/lib/scale";
import { ChartCanvas, Chart } from "react-stockcharts";
import { AreaSeries } from "react-stockcharts/lib/series";
import { XAxis, YAxis } from "react-stockcharts/lib/axes";
import { fitWidth } from "react-stockcharts/lib/helper";
import { last } from "react-stockcharts/lib/utils";

class AreaChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.getChartState(props.data, props.from, 0)
    };
  }

  getChartState = (chartData, from, initialIndex) => {
    const xScaleProvider = discontinuousTimeScaleProviderBuilder()
      .initialIndex(initialIndex)
      .inputDateAccessor(d => d.date);

    return {
      initialIndex,
      ...xScaleProvider(chartData)
    };
  };

  render() {
    const { type, width, ratio, padding } = this.props;
    const { data, xScale, xAccessor, displayXAccessor } = this.state;

    const margin = { left: padding, right: 40, top: 10, bottom: 30 };

    const height = 338;
    const gridHeight = height - margin.top - margin.bottom;
    const gridWidth = width - margin.left - margin.right;

    const showGrid = true;
    const yGrid = showGrid ? { innerTickSize: -1 * gridWidth } : {};
    const xGrid = showGrid ? { innerTickSize: -1 * gridHeight } : {};

    return (
      <div>
        <div style={{ position: "absolute" }}>
          <svg>
            <defs>
              <linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop
                  offset="0%"
                  stopColor={`rgba(${this.props.lineColor ||
                    "20, 98, 125, 1"})`}
                  stopOpacity=".4"
                />
                <stop
                  offset="30%"
                  stopColor={`rgba(${this.props.lineColor ||
                    "20, 98, 125, 1"})`}
                  stopOpacity=".2"
                />
                <stop
                  offset="100%"
                  stopColor={`rgba(${this.props.lineColor ||
                    "20, 98, 125, 1"})`}
                  stopOpacity="0"
                />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <ChartCanvas
          ref={node => {
            this.node = node;
          }}
          ratio={ratio}
          width={width}
          height={200}
          margin={margin}
          seriesName="MSFT"
          data={data}
          type="svg"
          xScale={xScale}
          xAccessor={xAccessor}
          displayXAccessor={displayXAccessor}
          mouseMoveEvent={false}
          panEvent={false}
          zoomEvent={false}
          clamp={false}
        >
          <Chart
            id={0}
            yExtents={d => d.close}
            padding={{ top: 10, right: 0, bottom: 10, left: 0 }}
          >
            <XAxis
              fontFamily="Roboto Condensed"
              axisAt="bottom"
              orient="bottom"
              {...xGrid}
              stroke={`rgba(${this.props.axisColor || "20, 98, 125, 1"})`}
              ticks={6}
              tickPadding={10}
              tickStrokeWidth={1}
              outerTickSize={0}
              tickStrokeDasharray={"ShortDash"}
              tickStrokeOpacity={0.1}
              tickStrokeWidth={1}
              tickStroke={`rgba(${this.props.axisColor || "20, 98, 125, 1"})`}
            />
            <YAxis
              fontFamily="Roboto Condensed"
              axisAt="right"
              orient="right"
              {...yGrid}
              ticks={4}
              tickPadding={10}
              outerTickSize={0}
              stroke={`rgba(${this.props.axisColor || "20, 98, 125, 1"})`}
              strokeWidth={1}
              tickStrokeDasharray={"ShortDash"}
              tickStrokeOpacity={0.1}
              tickStrokeWidth={1}
              tickStroke={`rgba(${this.props.axisColor || "20, 98, 125, 1"})`}
            />
            <AreaSeries
              yAccessor={d => d.close}
              fill="url(#grad1)"
              stroke={`rgba(${this.props.lineColor || "20, 98, 125, 1"})`}
              strokeWidth={1.5}
              strokeOpacity={1}
              opacity={1}
            />
          </Chart>
        </ChartCanvas>
      </div>
    );
  }
}

AreaChart.defaultProps = {
  lineColor: "20, 98, 125, 1",
  axisColor: "20, 98, 125, 1",
  bgColor: "0, 0, 0, 0"
};

AreaChart.propTypes = {
  data: PropTypes.array.isRequired,
  width: PropTypes.number.isRequired,
  ratio: PropTypes.number.isRequired
};

AreaChart = fitWidth(AreaChart);

export default AreaChart;
